(function($) {
	$(function() {
		if ( $('.recent-news-slider').length ) {
			const swiper = new Swiper('.recent-news-slider', {
				// Optional parameters
				direction: 'horizontal',
				loop: true,
				slidesPerView: 1,
				spaceBetween: 20,
				
				// Navigation arrows
				navigation: {
					nextEl: '.recent-news-slider-next',
					prevEl: '.recent-news-slider-prev',
				},

				// Breakpoints
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 30,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
			});
		}
	});
})(jQuery);